import React from "react";
import '../css/MyAccount.css'
import { useSelector } from "react-redux";
import { Link, Outlet } from 'react-router-dom';



const MyAccount = ({ isAuthenticated, active, setActive }) => {


    const { userId, userName } = useSelector(state => state.user);
    const { apiUrl } = useSelector(state => state.api);




    const changeSelection = (e) => {
        setActive(e.target.innerText);

    }

    return (
        <>
            {isAuthenticated ? (<div className="container-myaccount justify-content-center align-items-center" >
                <h2 className="text-center">Welcome to Account Management</h2>
                <h5 className="text-center">Manage information for your account </h5>
                <div className="row">

                    <div className="col-md-2 text-left">
                        <nav className="item-list ">
                            <div className="bg-light ">
                                <Link to="/myaccount" className="text-decoration-none text-reset">
                                    <div className={active === 'My Profile' ? 'item active' : 'item'} onClick={changeSelection}>My Profile</div>
                                </Link>
                            </div>
                            <div className="bg-light">

                                <Link to="/myaccount/password" className="text-decoration-none text-reset">
                                    <div className={active === 'Change password' ? 'item active' : 'item'} onClick={changeSelection}>Change password</div>
                                </Link>
                            </div>
                            <div className="bg-light">
                                <Link to="/myaccount/placeorders" className="text-decoration-none text-reset">
                                    <div className={active === 'Orders' ? 'item active' : 'item'}
                                        onClick={(e) => { changeSelection(e); }}
                                    >Orders</div>
                                </Link>
                            </div>
                        </nav>
                    </div>
                    {/* Profile */}
                    {/* Change password */}
                    {/* Orders*/}
                    {/* {(active === 'My Profile') ? (<Profile />) : (active === 'Change password') ? (<PassWord />) : (<PlaceOders />)} */}
                    <Outlet />
                </div>
            </div >) : (
                <div className="d-flex justify-content-center align-items-center">
                    <img src="/frusti.jpg"
                        alt="Not-Authorized"
                        class="notAuthor" ></img>
                </div>
            )}


        </>
    )

}

export default MyAccount;